var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.08 1.99329C10.7534 1.66662 10.2267 1.66662 9.90004 1.99329L4.36004 7.53329C4.10004 7.79329 4.10004 8.21329 4.36004 8.47329L9.90004 14.0133C10.2267 14.34 10.7534 14.34 11.08 14.0133C11.4067 13.6866 11.4067 13.16 11.08 12.8333L6.25337 7.99996L11.0867 3.16662C11.4067 2.84662 11.4067 2.31329 11.08 1.99329Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.149d02d056a5fa6beb28f731f0e1a28a.svg";
export { ForwardRef as ReactComponent };